import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["componentClass", "active", "disabled", "onClick", "eventKey", "className", "style", "iconBtn", "showTitle", "title", "type", "page", "itemRender"],
    _excluded2 = ["componentClass", "active", "disabled", "onClick", "eventKey", "className", "style", "iconBtn", "showTitle", "title", "type", "page", "itemRender"];
import "core-js/modules/es6.number.constructor.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import omit from "omit.js";
var propTypes = {
  className: PropTypes.string,
  eventKey: PropTypes.any,
  onSelect: PropTypes.func,
  disabled: PropTypes.bool,
  active: PropTypes.bool,
  onClick: PropTypes.func
};
var defaultProps = {
  componentClass: 'a',
  active: false,
  disabled: false
};

var PaginationButton = /*#__PURE__*/function (_React$Component) {
  _inherits(PaginationButton, _React$Component);

  var _super = _createSuper(PaginationButton);

  function PaginationButton(props, context) {
    var _this;

    _classCallCheck(this, PaginationButton);

    _this = _super.call(this, props, context);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PaginationButton, [{
    key: "handleClick",
    value: function handleClick(event) {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          onSelect = _this$props.onSelect,
          eventKey = _this$props.eventKey,
          pageSize = _this$props.pageSize;

      if (disabled) {
        return;
      }

      if (onSelect) {
        onSelect(eventKey, Number(pageSize), event);
      }
    }
  }, {
    key: "getItemRender",
    value: function getItemRender() {
      var _this$props2 = this.props,
          Component = _this$props2.componentClass,
          active = _this$props2.active,
          disabled = _this$props2.disabled,
          onClick = _this$props2.onClick,
          eventKey = _this$props2.eventKey,
          className = _this$props2.className,
          style = _this$props2.style,
          iconBtn = _this$props2.iconBtn,
          showTitle = _this$props2.showTitle,
          title = _this$props2.title,
          type = _this$props2.type,
          page = _this$props2.page,
          itemRender = _this$props2.itemRender,
          props = _objectWithoutProperties(_this$props2, _excluded);

      if (itemRender) {
        var render = itemRender(eventKey, type, /*#__PURE__*/React.createElement(Component, _extends({}, omit(props, ["pageSize", "defaultActivePage", "simple"]), {
          disabled: disabled,
          onClick: this.handleClick
        })));

        if (render) {
          return render;
        }
      }

      return /*#__PURE__*/React.createElement(Component, _extends({}, omit(props, ["pageSize", "defaultActivePage", "simple"]), {
        disabled: disabled,
        onClick: this.handleClick
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          Component = _this$props3.componentClass,
          active = _this$props3.active,
          disabled = _this$props3.disabled,
          onClick = _this$props3.onClick,
          eventKey = _this$props3.eventKey,
          className = _this$props3.className,
          style = _this$props3.style,
          iconBtn = _this$props3.iconBtn,
          showTitle = _this$props3.showTitle,
          title = _this$props3.title,
          type = _this$props3.type,
          page = _this$props3.page,
          itemRender = _this$props3.itemRender,
          props = _objectWithoutProperties(_this$props3, _excluded2);

      delete props.onSelect;
      return /*#__PURE__*/React.createElement("li", {
        title: showTitle ? title : undefined,
        className: classNames(className, {
          active: active,
          disabled: disabled,
          iconBtn: iconBtn
        }),
        style: style
      }, this.getItemRender());
    }
  }]);

  return PaginationButton;
}(React.Component);

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;
export default PaginationButton;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-pagination/src/PaginationButton.js